import { ASSUMPTION_STATUS } from '../types';

export const ASSUMPTION_STATUS_OPTIONS = {
  [ASSUMPTION_STATUS.VALID]: 'Valid',
  [ASSUMPTION_STATUS.VIOLATED]: 'Violated',
  [ASSUMPTION_STATUS.INACTIVE]: 'Inactive',
};

export const ASSUMPTION_STATUS_LABEL: Record<string, string> = {
  ...ASSUMPTION_STATUS_OPTIONS,
};
